exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-text[data-v-303f6396] {\n  border-radius: 8px 0px 0px 8px !important;\n}\n", ""]);

// exports
